import { toPersian } from '@/helpers/props'

interface IGenerateMetadata {
  minPrice: string | null
  houseCount: string
}

export const generateMetadata = ({
  minPrice,
  houseCount,
}: IGenerateMetadata) => {
  // finds random number between 250~350 by Math.floor(Math.random() * (max - min + 1) + min) formula
  const randomPrice = () => Math.floor(Math.random() * 101 + 250)
  const metadataSet = {
    cottage: {
      title: `اجاره کلبه چوبی و جنگلی از ${minPrice || `${toPersian(randomPrice())} هزار`} تومان${houseCount} کلبه |شب`,
      description: `اجاره کلبه چوبی و جنگلی ارزان و لوکس | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24 ساعته`,
      canonical: `https://www.shab.ir/all-cottage`,
      breadcrumb: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'شب',
            item: 'https://www.shab.ir',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'اجاره کلبه چوبی و جنگلی',
            item: 'https://www.shab.ir/all-cottage',
          },
        ],
      }),
    },
    boomgardi: {
      title: `رزرو اقامتگاه بوم گردی از ${minPrice || `${toPersian(randomPrice())} هزار`} تومان${houseCount} بومگردی |شب`,
      description:
        'رزرو اقامتگاه بوم گردی ارزان و لوکس | امنیت و نظافت تضمین شده | بیمه رایگان سفر و اقامت | پشتیبانی 24 ساعته',
      canonical: `https://www.shab.ir/all-boomgardi`,
      breadcrumb: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'شب',
            item: 'https://www.shab.ir',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'رزرو اقامتگاه بوم گردی',
            item: 'https://www.shab.ir/all-boomgardi',
          },
        ],
      }),
    },
  }
  return metadataSet
}
